import React from 'react';

interface Step1Props {
  selectedMethod: 'existing' | 'new' | null;
  onSelect: (method: 'existing' | 'new') => void;
  onSkip: () => void;
}

const Step1_IncomeMethod: React.FC<Step1Props> = ({ selectedMethod, onSelect, onSkip }) => {
  return (
    <div className="wizard-step">
      <div className="wizard-step-content">
        <h2 className="wizard-question">
          How do you want to earn income with covered calls?
        </h2>

        <div className="wizard-options-container">
          <button
            className={`wizard-pill-button ${selectedMethod === 'existing' ? 'selected' : ''}`}
            onClick={() => onSelect('existing')}
            aria-pressed={selectedMethod === 'existing'}
          >
            <div className="pill-button-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M3 3v18h18" />
                <path d="M18 17V9" />
                <path d="M13 17V5" />
                <path d="M8 17v-3" />
              </svg>
            </div>
            <div className="pill-button-content">
              <div className="pill-button-title">Use my existing shares</div>
              <div className="pill-button-subtitle">
                I already own stocks and want to generate income from them
              </div>
            </div>
          </button>

          <button
            className={`wizard-pill-button ${selectedMethod === 'new' ? 'selected' : ''}`}
            onClick={() => onSelect('new')}
            aria-pressed={selectedMethod === 'new'}
          >
            <div className="pill-button-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10" />
                <path d="M12 6v12" />
                <path d="M6 12h12" />
              </svg>
            </div>
            <div className="pill-button-content">
              <div className="pill-button-title">Buy new shares for income</div>
              <div className="pill-button-subtitle">
                I want to buy stocks specifically for covered call income
              </div>
            </div>
          </button>
        </div>

        <p className="wizard-helper-text">
          💡 Each covered call uses 100 shares. We'll guide you either way.
        </p>

        <button
          className="wizard-skip-button"
          onClick={onSkip}
          type="button"
          aria-label="Skip wizard and browse all stocks"
        >
          Skip and browse all stocks →
        </button>
      </div>
    </div>
  );
};

export default Step1_IncomeMethod;
